var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrasaVisceralImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.614,
    height: 17.582,
    viewBox: "0 0 17.614 17.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12764",
    "data-name": "Group 12764",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7314",
    "data-name": "Path 7314",
    d: "M3989.293,687.767a.864.864,0,0,1-.43-.52,11.7,11.7,0,0,1-.878-4.816,12.909,12.909,0,0,1,.638-3.764.315.315,0,0,0-.062-.344,2.687,2.687,0,0,1-.533-1.517,3.689,3.689,0,0,1,1.364-3.357.248.248,0,0,0,.072-.192,7.673,7.673,0,0,0-.479-1.832.5.5,0,0,1,.49-.74q4.22,0,8.44,0a.5.5,0,0,1,.492.738,8.428,8.428,0,0,0-.485,1.814.222.222,0,0,0,.1.236,3.643,3.643,0,0,1,1.295,2.136,4.011,4.011,0,0,1-.133,2.056,5.124,5.124,0,0,1-.385.713.309.309,0,0,0-.045.205,13.384,13.384,0,0,1,.633,3.33,11.761,11.761,0,0,1-.869,5.363.84.84,0,0,1-.416.49Zm1.127-14.978c.148-.058.285-.118.425-.166a.5.5,0,1,1,.351.934c-.128.054-.258.1-.383.163a2.916,2.916,0,0,0-1.792,2.989,1.714,1.714,0,0,0,.936,1.508,6.228,6.228,0,0,0,1.188.467,10.519,10.519,0,0,0,4.118.2,6.072,6.072,0,0,0,2.053-.592,1.664,1.664,0,0,0,.919-.942,2.84,2.84,0,0,0-.247-2.409,3.333,3.333,0,0,0-1.706-1.351c-.343-.134-.494-.392-.384-.678a.518.518,0,0,1,.736-.258c.113.042.223.09.339.136l.263-1.095h-7.079Zm-1.354,8.391c-.026.385-.062.749-.074,1.113a10.772,10.772,0,0,0,.7,4.329.193.193,0,0,0,.216.146c1.045,0,2.09,0,3.135,0,.048,0,.1-.005.157-.009v-.19c0-.917,0-1.835,0-2.752a.86.86,0,0,0-.131-.47,3.464,3.464,0,0,0-1.283-1.187,8.951,8.951,0,0,0-2.469-.929C3989.244,681.21,3989.169,681.2,3989.067,681.181Zm9.275,0c-.081.009-.114.009-.145.016a9.42,9.42,0,0,0-2.438.872,3.429,3.429,0,0,0-1.467,1.342.773.773,0,0,0-.09.345c-.007.94,0,1.879,0,2.819v.18c.041,0,.062.009.084.009,1.084,0,2.168,0,3.252,0,.114,0,.137-.06.169-.141a10.464,10.464,0,0,0,.7-3.928C3998.4,682.2,3998.365,681.7,3998.342,681.184Zm-4.644,1.286a7.908,7.908,0,0,1,4.455-2.295l-.272-1.041a10.711,10.711,0,0,1-8.368,0l-.267,1.041A7.9,7.9,0,0,1,3993.7,682.47Z",
    transform: "translate(-3985.156 -670.685)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7315",
    "data-name": "Path 7315",
    d: "M3924.437,824.956l.793-.894c-.043-.022-.1-.046-.149-.076a.5.5,0,0,1,.328-.92q.491.088.979.2a.479.479,0,0,1,.385.393c.063.3.121.6.18.9a.5.5,0,0,1-.337.619.5.5,0,0,1-.615-.318c-.008-.019-.02-.038-.04-.076l-.556.56c-.387.387-.7.35-.967-.114Z",
    transform: "translate(-3924.437 -816.282)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M3924.437,701.755c.034-.056.063-.115.1-.168a.5.5,0,0,1,.761-.05c.113.106.222.218.331.33s.207.217.324.34l.075-.145a.5.5,0,0,1,.591-.253.49.49,0,0,1,.348.541q-.086.509-.2,1.012a.47.47,0,0,1-.4.36q-.441.09-.882.175a.5.5,0,0,1-.3-.951c.02-.009.039-.02.074-.039-.19-.19-.379-.368-.555-.559a3.792,3.792,0,0,1-.261-.359Z",
    transform: "translate(-3924.437 -700.02)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7317",
    "data-name": "Path 7317",
    d: "M4252.451,824.758c-.031.073-.045.109-.062.143a.5.5,0,0,1-.6.265.492.492,0,0,1-.346-.557q.089-.491.2-.978a.462.462,0,0,1,.367-.369q.494-.11.995-.2a.5.5,0,0,1,.322.921c-.047.028-.1.049-.177.087.22.217.43.425.642.632a.5.5,0,1,1-.683.733c-.113-.106-.222-.218-.33-.33S4252.573,824.888,4252.451,824.758Z",
    transform: "translate(-4236.89 -816.278)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7318",
    "data-name": "Path 7318",
    d: "M4252.561,702.216c.222-.226.422-.433.627-.637a.5.5,0,1,1,.711.7c-.206.209-.415.415-.632.63.062.029.107.047.151.071a.5.5,0,0,1-.328.93c-.316-.059-.632-.12-.947-.19a.486.486,0,0,1-.4-.4c-.062-.3-.121-.6-.181-.9a.5.5,0,0,1,.949-.312C4252.527,702.135,4252.537,702.16,4252.561,702.216Z",
    transform: "translate(-4237.003 -700.026)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7319",
    "data-name": "Path 7319",
    d: "M4105.713,821.466a.5.5,0,1,1-.5.491A.5.5,0,0,1,4105.713,821.466Z",
    transform: "translate(-4097.168 -814.758)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrasaVisceralImage);
export default __webpack_public_path__ + "static/media/Grasa_visceral_image.bf9e1633004ed66568107cae68b5b0bf.svg";
export { ForwardRef as ReactComponent };